module.exports = __webpack_public_path__ + "static/media/temp-foto-hero-3.43a4bf01.jpg";